import React from "react";
import { Box } from "rebass";
import { motion } from "framer-motion";
import { observer } from "mobx-react-lite";
import { QRCodeSVG } from "qrcode.react";
import { useStores } from "../store/useStores";
import { SinglePageVariants } from "../animations/Variants";

interface QrCodeBadgeProps {
	url: string;
}

export const QrCodeBadge = observer(({ url }: QrCodeBadgeProps) => {
	const { ProjectionStore } = useStores();

	const isPortraitMode = ProjectionStore.deviceOrientation === "portrait";
	const size = isPortraitMode ? "11vh" : "30vh";

	return (
		<Box
			sx={{
				zIndex: 1,
				bg: "#f9fbf8",
				p: "1vh",
				bottom: isPortraitMode ? "2vh" : "4vh",
				right: isPortraitMode ? "2vh" : "4vh",
				position: "fixed",
				"& svg": {
					height: size,
					width: size,
					display: "block"
				}
			}}
		>
			<motion.div variants={SinglePageVariants.backVariants}>
				<QRCodeSVG
					value={url}
					level="H"
					size={300}
					includeMargin
					bgColor="#f9fbf8"
					imageSettings={{
						src: process.env.PUBLIC_URL + "/qr-logo.png",
						height: 78,
						width: 78,
						excavate: true
					}}
				/>
			</motion.div>
		</Box>
	);
});
